module.exports = __webpack_public_path__ + "img/1504017643.eef51fdc.jpg";